import React from 'react';
import { s } from '../styles';
import { InViewStep } from '../atoms';

// Screen 10 — Gentle Push numbered steps. 5 InView-gated steps along
// a vertical thread, with a marble dot dropping onto step 4 (the
// "picture this" elevator-level step). Hairline ticks at 6 / 50 / 94%
// echo the canal's III / II / I depths without competing with the
// step numerals on a 375px viewport.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <span style={s.pushEyebrow} className="screen-enter-child">{t('fl_push_steps_eyebrow')}</span>
      <h1 style={s.title} className="screen-enter-child">{t('fl_push_steps_title')}</h1>
      <div style={s.pushStepsList} className="screen-enter-child">
        <div style={s.pushStepsThread} aria-hidden="true" />
        {['6%', '50%', '94%'].map((top) => (
          <div key={top} style={{ ...s.pushStepsTick, top }} aria-hidden="true" />
        ))}
        {[0, 1, 2, 3, 4].map((i) => {
          const isMarble = i === 3;
          const body = <p style={s.pushStepBody}>{t(`fl_push_step_${i + 1}`)}</p>;
          return (
            <InViewStep key={i} index={i} isMarble={isMarble}>
              {isMarble ? (
                <div style={s.pushStepMarble}>
                  {body}
                  <span style={s.pushStepMarbleCaption}>{t('fl_push_step_4_caption')}</span>
                </div>
              ) : body}
            </InViewStep>
          );
        })}
      </div>
    </div>
  );
}

export function Footer({ t, onNext }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
      {t('fl_push_steps_cta')}
    </button>
  );
}
